module.exports = __webpack_public_path__ + "static/media/trash.77963a8c.svg";